function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.896 12a.562.562 0 00.641-.331s.136-.3.295-.802c.471-1.481 1.076-4.311-.142-6.666C6.06 1.05 1.84.086 1.52.014L1.508.01a.583.583 0 00-.642.331s-.128.303-.29.812C.107 2.628-.504 5.455.713 7.81 2.37 11.017 6.715 11.967 6.896 12zm2.357.482a.43.43 0 00.392.391s.251.03.654.03c1.192 0 3.4-.217 4.838-1.655 1.925-1.925 1.646-5.234 1.625-5.484v-.01a.447.447 0 00-.392-.392s-.251-.023-.66-.023c-1.186 0-3.395.21-4.832 1.648-1.958 1.958-1.642 5.354-1.625 5.495zm-.26 1.281H8.41v2.328h.582v-2.328z",
  fill: "#000"
})));